import { getCookie } from 'tiny-cookie'

import { authExternal } from '@/helpers/AuthExternal'
import { isLoggedIn } from '@/state/Authentication'
import { cartExpired, refreshStoredCart } from '@/state/Cart'
import store from '@/store/store'

export function initializeStores(): void {
  store.dispatch('Member/clearLegacy')
  const hasSessionCookie = getCookie('session_expires')
  if (isLoggedIn() && !hasSessionCookie) {
    // The session has expired. Clear all storage, but stay on the current URL.
    store.dispatch('clearAll')
  } else {
    initializeCartStore()
    initializeMemberStore()
  }
}

/**
 * Removes any known carts that have expired, are empty, or not pending (purchased/deleted elsewhere).
 * Seeds a Stripe wallet payment to check if digital wallets are supported before getting to checkout.
 */
function initializeCartStore(): void {
  if (cartExpired()) {
    store.dispatch('Cart/clearAll')
  } else if (store.getters['Cart/cart']) {
    // Reload the cart, which also confirms it is still valid.
    refreshStoredCart()
  }
}

/**
 * Initializes the members store in case an external authentication provider has set the cookie.
 */
function initializeMemberStore() {
  if (authExternal.isLoggedInExternally()) store.dispatch('Member/load')
}
